import { FCWithChildren } from 'common/types';
import Text, { TextProps } from 'components/_core/Text';

import { formatText } from './utils';

interface RichTextProps extends TextProps {
  children: string;
  renderStrong?: FCWithChildren;
}

/**
 * @deprecated Use Text instead (it now handles parsing rich text)
 */
const RichText: FCWithChildren<RichTextProps> = ({
  children,
  renderStrong,
  ...props
}) => (
  <Text as="div" {...props}>
    {formatText(children, { renderStrong })}
  </Text>
);

export default RichText;
